import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { License } from '../types';

export function useLicenses() {
  return useQuery({
    queryKey: queryKeys.updates.licenses,
    queryFn: () => apiClient.get<License[]>('/updates/licenses'),
  });
}
